
angular.module('v3sWbtPlayerApp').directive('v3sNavigation', ["v3sNavigationService", "v3sNavigationConfig", "v3sExerciseService", "v3sServiceFinder", function (v3sNavigationService, v3sNavigationConfig, v3sExerciseService, v3sServiceFinder) {
    return {
        restrict: 'E',
        scope: {
            page: '='
        },
        templateUrl: "app/js/navigation/navigation.tpl.html",
        controller: ["$scope", "$element", function ($scope, $element) {

            var v3sTimelineService = v3sServiceFinder.get("v3sTimelineService");
            var v3sToolsService = v3sServiceFinder.get("v3sToolsService");

            $scope.legalAnswer = false;

            var next = v3sNavigationService.getNextPage();
            var previous = v3sNavigationService.getPreviousPage();
            var nextState = v3sNavigationService.getNextPageState();
            var previousState = v3sNavigationService.getPreviousPageState();

            var hideableButtons = ['hidePrimaryNav', 'hideSecondaryNav', 'hideSearch', 'hideTree', 'hideBreadcrumb', 'hideManual', 'hideHome'];
            $scope.hideTheseButtons = [];

            function getButtonHideState(btn) {
                $scope.hideTheseButtons[btn] = $scope.page.getHideState(btn);
            }

            hideableButtons.forEach(getButtonHideState);

            var hideHiddenTools = function () {
                if ($scope.hideTheseButtons['hidePrimaryNav']) {
                    v3sToolsService.hideSearch();
                    v3sToolsService.hideTree();
                } else {
                    if ($scope.hideTheseButtons['hideTree']) {
                        v3sToolsService.hideTree();
                    }
                    if ($scope.hideTheseButtons['hideSearch']) {
                        v3sToolsService.hideSearch();
                    }
                }
            };

            var updateNavigationButtons = function () {
                hideHiddenTools();

                var navDisabled =
                    !v3sExerciseService.isIgnoreNavigationSetting()
                    && v3sNavigationConfig.enableNextPreviousOnlyIfCompleted
                    && !$scope.page.isCompleted()
                    && !$scope.page.getChildren
                    && $scope.page.isTrackable();

                $scope.allowNext = !!nextState && !!next && !next.isLocked() && !navDisabled;
                $scope.allowPrevious = !!previousState && !!previous && !previous.isLocked() && !navDisabled;
            };
            updateNavigationButtons();

            $scope.isAnimationPaused = false;
            $scope.isAnimationCompleted = false;

            $scope.hasNextStepExercise = false;
            $scope.isExerciseEvaluationVisible = true;

            $scope.page.subscribePageChanged($scope, function (event, changedPage) {
                $scope.$evalAsync(function () {
                    updateNavigationButtons();
                });
            });

            if (v3sTimelineService) {
                v3sTimelineService.subscribePaused($scope, function () {
                    $scope.$evalAsync(function () {
                        $scope.isAnimationPaused = true;
                    });
                });

                v3sTimelineService.subscribePlaying($scope, function () {
                    $scope.$evalAsync(function () {
                        $scope.isAnimationPaused = false;
                        $scope.isAnimationCompleted = !v3sTimelineService.isUserInteractionAllowed();
                    });
                });

                v3sTimelineService.subscribeCompleted($scope, function () {
                    $scope.$evalAsync(function () {
                        $scope.isAnimationCompleted = true;
                    });
                });
            } else {
                $scope.isAnimationCompleted = true;
            }

            var updateExerciseStatus = function () {
                if (v3sExerciseService.isInited()) {
                    if (v3sExerciseService.isCompleted()) {
                        $scope.hasNextStepExercise = false;
                    } else {
                        $scope.hasNextStepExercise = true;
                    }
                    $scope.isExerciseEvaluationVisible = v3sExerciseService.isExerciseEvaluationVisible();
                    $scope.legalAnswer = v3sExerciseService.isAnswered();
                }
            };
            updateExerciseStatus();

            v3sExerciseService.subscribeExerciseChanged($scope, function () {
                $scope.$evalAsync(function () {
                    updateExerciseStatus();
                });
            });

            $scope.nextPage = function nextPage() {
                if ($scope.hasNextStepExercise && $scope.legalAnswer) {
                    v3sExerciseService.checkAllExercisesLast();
                    $scope.hasNextStepExercise = false;
                } else {
                    v3sNavigationService.goToNext();
                }
            };

            $scope.prevPage = function prevPage() {
                if ($scope.hasNextStepExercise && $scope.legalAnswer) {
                    v3sExerciseService.checkAllExercisesLast();
                    $scope.hasNextStepExercise = false;
                } else {
                    v3sNavigationService.goToPrevious();
                }
            };

            $scope.nextStep = function nextStep() {
                if (v3sTimelineService && $scope.isAnimationPaused) {
                    v3sTimelineService.togglePause();
                } else if (v3sTimelineService && $scope.page && !$scope.isAnimationCompleted) {
                    v3sTimelineService.nextPeriod();
                } else if ($scope.page && $scope.hasNextStepExercise) {
                    v3sExerciseService.checkAllExercises();
                } else {
                    v3sNavigationService.goToNext();
                }
            };

            $scope.togglePause = function togglePause() {
                if (v3sTimelineService && !$scope.isAnimationCompleted) {
                    v3sTimelineService.togglePause();
                }
            };

            $scope.goHome = function goHome() {
                var homeItem = v3sNavigationService.getItem("home");
                var homeState = v3sNavigationService.getPageState(homeItem);
                v3sNavigationService.goTo(homeState);
            };

            if (v3sToolsService) {
                //Search
                $scope.showSearch = function showSearch() {
                    v3sToolsService.toggleSearch();
                };

                //Tree
                v3sToolsService.pageChanged($scope.page);
                $scope.showTree = function showTree() {
                    v3sToolsService.toggleTree($scope.page);
                };
            }

        }],
        link: function (scope, element, attrs) {
            //Öffnen des AudioSubtitles, wenn die navbar über den Subtitle hängt und Browser pointerEvents nicht unterstützt
            var secondarynav = angular.element(element[0].querySelector('.secondary-nav'));
            if (!!secondarynav[0] && !angular.isDefined(secondarynav[0].style.pointerEvents)) {
                secondarynav.on("click mousedown mousemove", function (evt) {
                    //Hide navigation und get the underlying element
                    secondarynav.css("display", "none");

                    //Get underlying Element
                    var under = angular.element(document.elementFromPoint(evt.pageX, evt.pageY));
                    under.triggerHandler(evt.type);

                    //Show navigation
                    secondarynav.css("display", "block");
                });
            }
        }
    };
}]);
